import React from 'react'
import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { getTimeZones } from '@vvo/tzdb'
import { match, nth, find, prop } from 'ramda'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  noBorder: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
}))

function TimeZoneSelector(props) {
  const { timezone, onChange, label, variant, disabled = false } = props
  const timezones = getTimeZones()
  const classes = useStyles()
  const timezoneSelected = find((item) => item.name === timezone, timezones)
  const changeValue = (event, newValue) => {
    if (onChange && newValue) {
      onChange(newValue.name)
    }
  }

  return (
    <div className={clsx('flex sm:space-x-4', classes.noBorder)}>
      <Autocomplete
        className={clsx(
          props.className,
          'bg-white rounded-8 border border-grey-input text-grey-100',
        )}
        id="timezoneSelector"
        value={timezoneSelected || null}
        autoHighlight
        options={timezones}
        getOptionLabel={(option) => {
          const result = match(/^([+-]\d{2}:\d{2})\s(.+)$/, option.rawFormat)
          const offset = nth(1, result)
          const description = nth(2, result)
          return `(GMT${offset}) ${description}`
        }}
        getOptionSelected={(option, value) =>
          option.name === prop('name', value)
        }
        onChange={changeValue}
        readOnly={disabled}
        disabled={disabled}
        renderInput={(params) => <TextField {...params} variant={variant} />}
      />
    </div>
  )
}

export default React.memo(TimeZoneSelector)
